// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2txAO","colMin":"styles_colMin__34WiZ"};